/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyV2Base {
    getFixupPrototypeFunction() { return PolicyV2Base.fixupPrototype; }

    static newInstance(model: Partial<PolicyV2Base>): PolicyV2Base {
        let obj = Object.assign(new PolicyV2Base(), model);
        PolicyV2Base.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyV2Base>): PolicyV2Base {
        if (!model) return null;
        return PolicyV2Base.newInstance(<PolicyV2Base> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyV2Base) {
        if (!obj) return;

        models.PolicyV2Base.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyV2Base): boolean {
        Object.setPrototypeOf(obj, PolicyV2Base.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.notifications) {
            models.ConfigurationForNotifications.fixupPrototype(this.notifications);
        }
        if (this.parameters) {
            for (let val of this.parameters) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.PolicyV2Recommendation.fixupPrototype(val);
            }
        }
        if (this.integrated_tool_account) {
            for (let val of this.integrated_tool_account) {
                models.PolicyIntegratedToolAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Policy name which is unique and does not allow special characters or spaces
     */
    name: string;

    /**
     * A brief explanation of the policy
     */
    description: string;

    /**
     * Engine type of the policy
     */
    engine_type: models.PolicyEngineType;

    /**
     * Policy scope
     */
    scope: models.PolicyV2Scope;

    /**
     * Classification of the policy
     */
    classification: models.PolicyClassification;

    /**
     * Sub-classification of the policy
     */
    sub_classification: models.PolicySubClassification;

    /**
     * Severity of policy
     */
    severity: models.PolicySeverity;

    /**
     * Policy content source (file or git)
     */
    content_type: models.PolicyContentType;

    /**
     * The policy content as a JSON object, required when content_type is file
     */
    raw_content: any;

    /**
     * Policy parameters as a list of named parameters
     */
    parameters: Array<models.NamedParameter>;

    /**
     * List of recommendations for the policy
     */
    recommendations: Array<models.PolicyV2Recommendation>;

    /**
     * Flag to identify system policies
     */
    is_system_policy: boolean;

    /**
     * Resource category in the resource_category-resource_type-resource hierarchy
     */
    resource_category: string;

    /**
     * Resource type in the service-resource_type-service_resource hierarchy
     */
    resource_type: string;

    /**
     * Service resources in the service-resource_type-service_resource hierarchy
     */
    service_resource: Array<string>;

    /**
     * Policy content filename, stored as metadata file in the backend
     */
    file: string;

    /**
     * Default notification routing for this policy's activity
     */
    notifications: models.ConfigurationForNotifications;

    /**
     * Integrated tool accounts (e.g. ServiceNow) to notify for this policy's activity
     */
    integrated_tool_account: Array<models.PolicyIntegratedToolAccount>;

    /**
     * Cloud activity events that triggers an execution of this policy
     */
    trigger_activity_actions: Array<string>;

}
